import { h } from '@stencil/core';
import { getLocaleFromBody, HMCPlatform, MY_SCHNEIDER_CLICK_EVENT, HMC_CLOSE_EVENT } from '@pes-ui/utils';
import { isBrowser } from '../../../../../globals/utils';
export class HmcModalContainer {
  componentWillLoad() {
    const { languageCode, countryCode } = getLocaleFromBody(isBrowser) || {};
    this.languageCode = languageCode;
    this.countryCode = countryCode;
    this.isloggedIn = Boolean(window.isPBS);
    this.isOpened = true;
  }
  constructor() {
    this.host = undefined;
    this.token = undefined;
    this.channel = undefined;
    this.pageSource = undefined;
    this.closeModal = undefined;
    this.isOpened = false;
    this.languageCode = undefined;
    this.countryCode = undefined;
    this.isloggedIn = false;
    this.handleClose = this.handleClose.bind(this);
    window.addEventListener(HMC_CLOSE_EVENT, this.handleClose);
  }
  handleClose() {
    var _a;
    this.isOpened = false;
    (_a = this.closeModal) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  disconnectedCallback() {
    var _a;
    window.removeEventListener(HMC_CLOSE_EVENT, this.handleClose);
    (_a = this.closeModal) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  render() {
    return (h("se-dialog", { open: this.isOpened }, h("wc-help-me-choose", { host: this.host, language: this.languageCode, country: this.countryCode, channel: this.channel, token: this.token, platform: this.isloggedIn ? HMCPlatform.MySchneider : HMCPlatform.SE, pageSource: this.pageSource, outputLinkClickEvent: this.isloggedIn ? MY_SCHNEIDER_CLICK_EVENT : '', addToCartEvent: 'scSelectorAddToCart', closeEvent: HMC_CLOSE_EVENT })));
  }
  static get is() { return "pes-hmc-modal-container"; }
  static get properties() {
    return {
      "host": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "host",
        "reflect": false
      },
      "token": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "token",
        "reflect": false
      },
      "channel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "channel",
        "reflect": false
      },
      "pageSource": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "page-source",
        "reflect": false
      },
      "closeModal": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "() => void",
          "resolved": "() => void",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "isOpened": {},
      "languageCode": {},
      "countryCode": {},
      "isloggedIn": {}
    };
  }
}
